import type { FaireProductEntity } from "../../entity_types/product";

export const p_95bzg6hcm6: FaireProductEntity = {
  token: "p_95bzg6hcm6",
  type: "product",
  name: "Oyakoneko Porcelain Tayo Medium Bowl – 6 in. Round, 19 oz JP",
  brandToken: "b_m8c3mbnsfa",
  brandName: "Urban Tokyo",
  imageUrl: "https://cdn.faire.com/fastly/1fdb362a68fc9323b897c5baba1446f351ce218e4d3601630372d8317ebfdf23.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0bf4c6b4937852030052235fe453a63d04c29954dc16475d02f2c810a60b1b1f.jpeg",
    "https://cdn.faire.com/fastly/ad5f42effc5758d46ad4ab70b8a3b36bd10f908d834a906a8f0e66b316af4703.jpeg",
    "https://cdn.faire.com/fastly/172bb125e4ddd3023d2dfff3f81e31bb90227bf5487dd54961e6c40744866066.jpeg",
    "https://cdn.faire.com/fastly/74d3428290b9e8832f051957db208cf137999352a9d020511c1198c44d0cff2b.jpeg",
    "https://cdn.faire.com/fastly/e020f790104d7fb544cab749caf4361648bfd084acdf58a5a55eab4189751e51.jpeg"
  ],
  priceDollars: 3.5,
  description: "Bring a refined, restaurant-ready look to the table with this 6\" tayo medium bowl in the Oyakoneko design. A multipurpose bowl for rice bowls, soups, salads, noodles and side dishes. Made in Japan from durable porcelain, it is built for busy restaurants, sushi bars, ramen shops, cafés and catering, while looking just as good on the family dinner table.\n\nFeatures\n\n * Quality porcelain: a classic glazed finish for everyday restaurant and home use \n * Easy care: microwave and dishwasher safe \n * Coordinated collection: mix with other Tayo medium bowl designs, rice bowls and ramen bowls for a coordinated or mix-and-match table setting \nSpecifications\n\n * Size: 6\" Dia x 2.75\" H \n * Capacity: 19 fl oz \n * Material: Porcelain \n * Series: Tayo \n * Design: Oyakoneko \n * Inner pack: 6 \n * Case pack: 48 \n * Origin: Japan \n * Care: Microwave and dishwasher safe. ",
  tags: [],
  msrpDollars: 7.87,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:02:51.919Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
